/**
 * Created by andrey on 21.10.2021.
 */

const UnitPacker = {
    compactKey: function (key) {
        return UnitPacker.ENCODE_KEYS[key] || key;
    },

    expandKey: function (key) {
        return UnitPacker.DECODE_KEYS[key] || key;
    },

    compactSeconds: function (time) {
        return Math.ceil(time / 1000);
    },

    expandSeconds: function (time) {
        return Math.round(time * 1000);
    },

    compactCoordinate: function (number) {
        if (number < 80) {
            return Base80.compactNumber(number);
        }
        return UnitPacker.ENCODE_DELIMITERS[Math.floor(number / 80)] + Base80.compactNumber(number % 80);
    },

    compactCoordinates: function (numbers) {
        return numbers.map(UnitPacker.compactCoordinate).join("");
    },

    expandCoordinate: function (string) {
        const index = UnitPacker.DECODE_DELIMITERS[string.charAt(0)];
        if (index === undefined) {
            return Base80.expandNumber(string);
        }
        return index * 80 + Base80.expandNumber(string.charAt(1));
    },

    expandCoordinates: function (string) {
        const numbers = [];

        let index = 0, number;

        while (index < string.length) {
            number = this.readCoordinate(string, index);
            index += number.length;

            numbers.push(this.expandCoordinate(number));
        }

        return numbers;
    },

    compactUnits: function (units, code) {
        units = units.slice().sort((a, b) => (b.stage - a.stage) || (a.y !== b.y) || (a.x - b.x));

        const data = units.map((unit) => unit._compact || UnitPacker.compactUnit(unit, code)).join("");

        return PropertiesPacker.compactProperties(data, UnitPacker.splitUnits);
    },

    compactUnit: function (unit, code) {
        const info = cleverapps.clone(unit, true);

        if (info.x === undefined || info.y === undefined || info.stage === undefined || code === undefined && unit.code === undefined) {
            throw new Error(`Incorrect data: x=${info.x} y=${info.y} stage=${info.stage} code=${code || unit.code} unit=${JSON.stringify(unit)}`);
        }

        let result = UnitPacker.compactCoordinate(info.x)
            + UnitPacker.compactCoordinate(info.y)
            + Base80.compactNumber(info.stage);

        code = code || info.code;

        const family = Families[code];

        let familyStage = unit.stage;
        const deletedStages = Families.DELETED_STAGES && Families.DELETED_STAGES[code];
        if (deletedStages) {
            for (let i = 0; i < deletedStages.length && deletedStages[i] <= unit.stage; i++) {
                familyStage -= 1;
            }
        }

        const unitData = family && family.units[familyStage] || {};

        delete info.x;
        delete info.y;
        delete info.stage;

        const properties = [];

        if (unit.unbuilt && unit.time) {
            delete info.unbuilt;
        }

        for (const key in info) {
            let value = info[key];

            if (value === undefined || value === null || UnitPacker.DISABLED_PROPERTIES[key]) {
                continue;
            }

            if (["mined", "state"].indexOf(key) !== -1 && value === 0 && unitData.mineable) {
                continue;
            }

            if (UnitPacker.TIME_KEYS[key]) {
                value = cleverapps.compactTime(value);
            }
            if (UnitPacker.SECONDS_KEYS[key]) {
                value = this.compactSeconds(value);
            }
            if (UnitPacker.NUMBER_KEYS[key]) {
                value = Base80.compactNumber(value);
            }

            if (key === "unbuilt" && value) {
                value = 1;
            }

            if (typeof value === "string") {
                value = this.encodeString(value);
            }

            const encodedKey = this.compactKey(key);

            if (cleverapps.config.debugMode && encodedKey.length > 2) {
                UnitPacker.reportedKeys = UnitPacker.reportedKeys || {};
                if (!UnitPacker.reportedKeys[key]) {
                    UnitPacker.reportedKeys[key] = true;
                    cleverapps.throwAsync(`UnitPacker.compactKey is long - ${key}, unit - ${JSON.stringify(unit)}, code - ${code}`);
                }
            }

            const delimiter = encodedKey.length > 1 ? ":" : "";
            const encoded = encodedKey + delimiter + value;

            properties.push(encoded);
        }

        if (properties.length) {
            result += `{${properties.join(",")}}`;
        }
        
        return result;
    },

    expandUnits: function (data, code) {
        data = PropertiesPacker.expandProperties(data, UnitPacker.splitUnits);

        const list = UnitPacker.splitUnits(data);

        const units = [];

        list.forEach((item) => {
            const unit = UnitPacker.expandUnit(item, code);
            if (unit) {
                unit._compact = item;
                units.push(unit);
            }
        }, this);

        return units;
    },

    expandUnit: function (data, code) {
        const unit = {};

        const coordinates = UnitPacker.splitCoordinates(data, 0);

        unit.x = UnitPacker.expandCoordinate(coordinates.x);
        unit.y = UnitPacker.expandCoordinate(coordinates.y);
        unit.stage = Base80.expandNumber(data.charAt(coordinates.x.length + coordinates.y.length));

        let familyStage = unit.stage;
        const deletedStages = Families.DELETED_STAGES && Families.DELETED_STAGES[code];
        if (deletedStages) {
            for (let i = 0; i < deletedStages.length && deletedStages[i] <= unit.stage; i++) {
                familyStage -= 1;
            }
        }

        const family = Families[code];
        if (!family || !family.units[familyStage]) {
            unit.code = code;
            unit._unknown = true;
            return unit;
        }

        data = data.substr(coordinates.x.length + coordinates.y.length + 1);

        if (data.length > 0 && data.charAt(0) === "{" && data.charAt(data.length - 1) === "}") {
            data = data.substr(1, data.length - 2);
            data.split(",").forEach(function (property) {
                const parts = property.split(":");
                let key = parts.length === 1 ? property.charAt(0) : parts[0];
                let value = parts.length === 1 ? property.substr(1) : parts[1];

                key = this.expandKey(key);

                if (typeof value === "string") {
                    value = this.decodeString(value);
                }

                if (UnitPacker.NUMBER_KEYS[key]) {
                    value = Base80.expandNumber(value);
                }
                if (UnitPacker.SECONDS_KEYS[key]) {
                    value = this.expandSeconds(value, key);
                }
                if (UnitPacker.TIME_KEYS[key]) {
                    value = cleverapps.expandTime(value);
                }

                unit[key] = cleverapps.castType(value);
            }, this);
        }

        code = unit.code = code || unit.code;

        const unitData = Families[code] && Families[code].units[familyStage];
        if (unitData) {
            if (unitData.mineable) {
                unit.state = unit.state || 0;
                unit.mined = unit.mined || 0;
            }

            if (unitData.buildable && unit.time) {
                unit.unbuilt = true;
            }
        }

        return unit;
    },

    splitUnits: function (data) {
        const units = [];
        let index, length, coordinates, endIndex;
        for (index = 0; index < data.length;) {
            coordinates = UnitPacker.splitCoordinates(data, index);

            length = coordinates.x.length + coordinates.y.length + 1;

            if (data.charAt(index + length) === "{") {
                endIndex = data.indexOf("}", index + length);
                length = endIndex + 1 - index;
            }

            units.push(data.substr(index, length));
            index += length;
        }
        return units;
    },

    readCoordinate: function (data, index) {
        let x = data.charAt(index);

        if (UnitPacker.DECODE_DELIMITERS[x] !== undefined) {
            x += data.charAt(index + 1);
        }

        return x;
    },

    splitCoordinates: function (data, index) {
        const x = this.readCoordinate(data, index);
        const y = this.readCoordinate(data, index + x.length);
        return { x, y };
    },

    encodeString: function (string) {
        if (string.match(UnitPacker.ENCODED_TEST)) {
            if (string.includes(UnitPacker.ESCAPE)) {
                throw `can't encode \` in string ${string}`;
            }

            string = string
                .replace(UnitPacker.DECODED_TEST, (match) => UnitPacker.ESCAPE + match)
                .replace(UnitPacker.ENCODED_TEST, (match) => UnitPacker.DECODED_CHARS[UnitPacker.ENCODED_CHARS.indexOf(match)]);
            return UnitPacker.ESCAPE + string + UnitPacker.ESCAPE;
        }
        return string;
    },

    decodeString: function (string) {
        if (string.length > 1 && string[0] === UnitPacker.ESCAPE && string[string.length - 1] === UnitPacker.ESCAPE) {
            return string
                .slice(1, -1)
                .replace(UnitPacker.DECODED_TEST, (match, offset, string) => (string[offset - 1] === UnitPacker.ESCAPE ? match : UnitPacker.ENCODED_CHARS[UnitPacker.DECODED_CHARS.indexOf(match)]))
                .replace(/`/g, "");
        }
        return string;
    }
};

UnitPacker.ENCODE_KEYS = {
    amount: "a",
    appearTime: "A",
    changedLevels: "c",
    code: "C",
    extraMined: "e", // was used by mineable
    episode: "E",
    harvested: "h",
    grounded: "g",
    sinceLastHarvest: "H",
    lastHarvested: "i",
    level: "l",
    limit: "L",
    mined: "m",
    minTime: "M",
    progress: "p",
    prizesCount: "P",
    points: "q",
    pointsValue: "Q",
    recipe: "r",
    seed: "R",
    stage: "s",
    state: "S",
    time: "t",
    timeToReady: "T",
    unbuilt: "u",
    lockTime: "k",
    value: "v",
    pending: "n",
    choice: "x", // was used by switchable,
    fri: "f"
};

UnitPacker.TIME_KEYS = cleverapps.createSet(["sinceLastHarvest", "lastHarvested", "timeToReady", "lockTime", "appearTime"]);

UnitPacker.SECONDS_KEYS = cleverapps.createSet(["time", "limit"]);

UnitPacker.NUMBER_KEYS = cleverapps.createSet([
    "limit", "time", "sinceLastHarvest", "lastHarvested", "timeToReady", "harvested", "points", "pointsValue", "lockTime", "appearTime", "pending"
]);

UnitPacker.DECODE_KEYS = {};

UnitPacker.DISABLED_PROPERTIES = cleverapps.createSet(["_compact", "_unknown"]);

UnitPacker.ESCAPE = "`";

UnitPacker.ENCODED_CHARS = [",", ":", "[", "]", "{", "}"];
UnitPacker.DECODED_CHARS = ["+", "=", "(", ")", "<", ">"];

/* eslint-disable-next-line no-useless-escape */
UnitPacker.ENCODED_TEST = /[,:\[\]{}]/g;
UnitPacker.DECODED_TEST = /[+=()<>]/g;

UnitPacker.DELIMITERS = ";~_'.";
UnitPacker.ENCODE_DELIMITERS = {};
UnitPacker.DECODE_DELIMITERS = {};

(function () {
    for (const key in UnitPacker.ENCODE_KEYS) {
        const encoded = UnitPacker.ENCODE_KEYS[key];
        if (UnitPacker.DECODE_KEYS[encoded]) {
            throw `Double keys encode to ${encoded}`;
        }
        UnitPacker.DECODE_KEYS[encoded] = key;
    }

    for (let index = 0; index < UnitPacker.DELIMITERS.length; ++index) {
        UnitPacker.ENCODE_DELIMITERS[index + 1] = UnitPacker.DELIMITERS.charAt(index);
        UnitPacker.DECODE_DELIMITERS[UnitPacker.DELIMITERS.charAt(index)] = index + 1;
    }
}());

if (typeof cc === "undefined") {
    module.exports = UnitPacker;
}
